require('../../modules/es.typed-array.int16-array');
require('./methods');
var global = require('../../internals/global');

module.exports = global.Int16Array;
